import { PageType } from '@invideoio/web-shared/types/Analytics';
import { registerAndSendPageViewEvent } from '@invideoio/web-shared/utils/analytics/Register';
import React, { useEffect } from 'react';
interface IToolLandingLayoutProps {
  children: React.ReactNode;
}

function ToolLandingLayout(props: IToolLandingLayoutProps) {
  useEffect(() => {
    registerAndSendPageViewEvent(PageType.TOOLS, {
      location: window.location.href,
    });
  }, []);

  return (
    <React.Fragment>
      <main>{props.children}</main>
    </React.Fragment>
  );
}

export default ToolLandingLayout;
